import { css } from "@emotion/react";
import { forwardRef, Ref } from "react";
import { Tag as AriaTag, TagProps } from "react-aria-components";

const tagCSS = css`
  border: 1px solid var(--global-border-color-light);
  forced-color-adjust: none;
  border-radius: var(--global-rounding-small);
  padding: var(--global-dimension-size-50) var(--global-dimension-size-100);
  font-size: var(--global-font-size-s);
  color: var(--global-text-color-900);
  outline: none;
  cursor: default;
  display: flex;
  align-items: center;
  transition: all 200ms;

  &[data-hovered] {
    border-color: var(--global-border-color-dark);
  }

  &[data-focus-visible] {
    outline: 1px solid var(--global-color-primary);
    outline-offset: 1px;
  }

  &[data-selected] {
    border-color: var(--global-color-primary);
    background: var(--global-color-primary-700);
  }
`;
function Tag(props: TagProps, ref: Ref<HTMLDivElement>) {
  return <AriaTag {...props} ref={ref} css={tagCSS} />;
}

const _Tag = forwardRef(Tag);
export { _Tag as Tag };
export type { TagProps };
